<template>
  <div class="page_finCost">
    <div class="topOperation">
      <div class="top-left">
        <ShowNavHead />
        <div class="flex aic" v-if="activeName2=='1'">
          <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="88px">
            <el-form-item label="项目名称" size="small">
              <el-select v-model="listQuery.serviceProject" placeholder="" value-key="Projectid" size="small" style="width: 180px;" clearable filterable>
                <el-option v-for="(item, index) in proNameList" :key="index" :label="item.StrprojectName" :value="item.StrprojectName"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="成本月" size="small">
              <el-date-picker v-model="listQuery.CostMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="申报月" size="small">
              <el-date-picker v-model="listQuery.AttrMonth" type="month" value-format="yyyy-MM" size="small" style="width: 180px;">
              </el-date-picker>
            </el-form-item>
          </el-form>
          <div class="screenInput">
            <el-tooltip class="scr_icon" effect="dark" content="高级检索项" placement="top-start">
              <i class="i_txt" @click="dropDownScreen">{{ showDropScreen == 1 ? '收起' : '更多' }}<i class="el-icon-caret-bottom"></i></i>
            </el-tooltip>
          </div>
        </div>
      </div>
      <div class="top-right">
        <el-button v-if="showDropScreen == -1" v-preventReClick type="success" size="small" @click="searchHandle" style="margin-right: 15px;">搜索</el-button>
      </div>
    </div>
    <!-- 筛选下拉框 -->
    <div class="r_dropDownScreen" v-show="showDropScreen == 1">
      <div class="pro_down_box">
        <el-form :inline="true" :model="listQuery" class="re_down_form" label-width="90px">
          <div>
            <el-form-item label="暂支人" size="small">
              <el-input v-model="listQuery.tempPayee" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="类别" size="small">
              <el-select v-model="listQuery.AdvanceType" placeholder="" clearable filterable style="width:180px">
                <el-option value="发薪"></el-option>
                <el-option value="核销"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="垫资编号" size="small">
              <el-input v-model="listQuery.advanceNum" size="small" clearable style="width:180px"></el-input>
            </el-form-item>
            <el-form-item label="垫资用途" size="small">
              <el-input v-model="listQuery.useFunds" size="small" clearable style="width:180px"></el-input>
            </el-form-item>

          </div>
          <!-- <div>
            <el-form-item label="客服" size="small">
              <el-input v-model="listQuery.name" size="small" clearable></el-input>
            </el-form-item>
          </div> -->
        </el-form>
      </div>
      <div class="drop-footer">
        <el-button size="small" plain @click="resetHandle()">清空</el-button>
        <el-button size="small" type="info" plain @click="showDropScreen = -1">关闭</el-button>
        <el-button v-preventReClick size="small" type="success" @click="searchHandle()">搜索</el-button>
      </div>
    </div>
    <div class="main-con">
      <div class="crumbs">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item>收支</el-breadcrumb-item>
          <el-breadcrumb-item>垫资</el-breadcrumb-item>
          <el-breadcrumb-item>财务成本</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <div class="ftabs">
        <!-- <div class="checkedgroup" v-if="activeName2=='1'">
          <div class="checkboxTitle">垫资用途：</div>
          <div class="checkedgroup2">
            <el-checkbox-group v-model="p_grouytype">
              <el-checkbox v-for="(item,index) in busTypeList" :key="index" :label="item"></el-checkbox>
            </el-checkbox-group>
          </div>
        </div>
        <div class="checkedgroup" v-if="activeName2=='1'">
          <div class="checkboxTitle">支出方式：</div>
          <div class="checkedgroup2">
            <el-checkbox-group v-model="p_grouytype1">
              <el-checkbox v-for="(item,index) in busTypeList2" :key="index" :label="item"></el-checkbox>
            </el-checkbox-group>
          </div>
        </div> -->
        <el-tabs v-model="activeName" type="card" @tab-click="changeTab">
          <el-tab-pane label="全部" name="全部" v-if="checkPermission(['advList_all'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="未核销" name="未核销" v-if="checkPermission(['advList_notWriteOff'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="已核销" name="已核销" v-if="checkPermission(['advList_WriteOff'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="垫资成本" name="垫资成本" v-if="checkPermission(['advList_cost'], permissionLists)"></el-tab-pane>
        </el-tabs>
        <el-tabs v-model="activeName2" @tab-click="changeTab2">
          <el-tab-pane label="垫资成本报表" name="1" v-if="checkPermission(['advList_cost_report'], permissionLists)"></el-tab-pane>
          <el-tab-pane label="计算垫资成本" name="0" v-if="checkPermission(['advList_cost_calc'], permissionLists)"></el-tab-pane>

        </el-tabs>

        <div v-if="activeName2=='0'">
          <el-form :model="setForm" ref="setForm" label-width="160px">
            <el-form-item label="每月计算" size="small">
              <el-radio-group v-model="setForm.type" @input="changeRidio">
                <el-radio :label="1">不自动计算</el-radio>
                <el-radio :label="2">自动计算上月</el-radio>
                <el-radio :label="3">自动计算本月</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="自动计算时间" size="small">
              <div class="flex">
                <el-select v-model="setForm.day" size="small" clearable filterable style="width:140px;margin-right:20px" placeholder="" :disabled="!setForm.type || setForm.type=='1'">
                  <el-option v-for="(item, index) in 31" :key="index" :value="item" :label="item + '日'"></el-option>
                  <!-- <el-option value="31" label="每月最后一天"></el-option> -->
                </el-select>
                <el-time-picker v-model="time" placeholder="" value-format="HH:mm:ss" :disabled="!setForm.type || setForm.type=='1'">
                </el-time-picker>
                <el-button type="success" v-preventReClick @click="onSubmit" size="small" style="margin-left:15px" :loading="isBtnLoading"  v-if="checkPermission(['advList_cost_calc_save'], permissionLists)">保存</el-button>
              </div>
              <!-- <div class="record">张三 2024/1/24 09:02:01 设置： 每月1日20:00:00</div> -->
            </el-form-item>

            <el-form-item label="手动计算/刷新指定月份" size="small">
              <div class="flex">
                <el-date-picker type="month" placeholder="" v-model="handelMonth" value-format="yyyy-MM" style="width:180px;" size="small"></el-date-picker>
                <el-button type="warning" v-preventReClick size="small" style="margin-left:10px" @click="handelCal" v-if="checkPermission(['advList_cost_calc_refresh'], permissionLists)">计算/刷新</el-button>
              </div>
            </el-form-item>

          </el-form>

          <div>
            <div class="calTitle"><span class="titleLine">|</span> 计算记录</div>
            <div class="calList">
              <div class="calItem" v-for="(item,index) in calList" :key="index">
                {{ item.createTime.replace('T',' ') }} 生成 {{ item.busiId }} {{ item.msg }} {{ item.msg1 }}
              </div>
            </div>
          </div>
        </div>
        <div class="ftabBtn flex" v-if="activeName2=='1'">
          <el-popconfirm title="请确认是否选中计提？" v-if="checkPermission(['advList_cost_provision'], permissionLists)" @confirm="mulProfitProvision" style="margin: 0 10px;">
            <el-button type="success" size="small" slot="reference">选中计提</el-button>
          </el-popconfirm>
          <el-popconfirm title="请确认是否根据当前筛选条件全部计提？" v-if="checkPermission(['advList_cost_provision'], permissionLists)" @confirm="allProvision" style="margin: 0 10px;">
            <el-button type="danger" size="small" slot="reference">全部计提</el-button>
          </el-popconfirm>
          <el-button type="primary" size="small" @click="expList" :loading="isExping" v-if="checkPermission(['advList_export'], permissionLists)">导出</el-button>
        </div>
        <el-table :data="tableData" border v-if="activeName2=='1'" class="doc_table" v-loading="loading" style="width:100%" @selection-change="handleSelectionChange">
          <el-table-column type="selection" align="center" width="45" fixed="left">
          </el-table-column>
          <el-table-column prop="costMonth" label="月度" min-width="100" :show-overflow-tooltip="true" align="center" fixed="left">
          </el-table-column>
          <el-table-column prop="advanceNum" label="垫资编号" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="advanceType" label="类别" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="writtenNum" label="核销编号" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="attrMonth" label="归属月" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="temporaryCost" label="垫资成本" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="name" label="计提状态" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.provision==1 ? '已计提' : '未计提'}}</template>
          </el-table-column>
          <el-table-column prop="suspenseAmount" label="垫资金额" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="writtenAmount" label="已核销金额" min-width="140" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="notWrittenAmount" label="未核销金额" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="suspendStartTime" label="垫资开始时间" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.suspendStartTime ? row.suspendStartTime.split('T')[0] : '' }}</template>
          </el-table-column>
          <el-table-column prop="suspendEndTime" label="垫资结束时间" min-width="100" :show-overflow-tooltip="true" align="center">
            <template slot-scope="{row}">{{ row.suspendEndTime ? row.suspendEndTime.split('T')[0] : '' }}</template>
          </el-table-column>
          <el-table-column prop="totalSuspensionDay" label="总垫资天数" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="countingDay" label="本月计算天数" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="serviceProject" label="服务项目" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="servicDep" label="服务部门" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="partner" label="合伙人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="attrPerform" label="业绩归属人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="tempPayee" label="暂支人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="personRespons" label="责任人" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="useFunds" label="垫资用途" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column prop="expendMethod" label="支出方式" min-width="100" :show-overflow-tooltip="true" align="center">
          </el-table-column>
          <el-table-column label="操作" align="center" width="80px" fixed="right">
            <template slot-scope={row}>
              <div class="injuryTabBtn">
                <el-button type="text" @click="ProfitProvision(row.id,row.provision) && checkPermission(['advList_cost_provision'], permissionLists)" v-if="row.provision!=1">计提</el-button>
              </div>
            </template>
          </el-table-column>

        </el-table>

        <div class="block">
          <el-pagination v-if="totalCount>0" @current-change="currentChange" :current-page.sync="listQuery.PageModel.Page" :page-size="Number(listQuery.PageModel.Rows)" @size-change="handleSizeChange" :page-sizes="[10,20, 50, 100, 200]" layout="total,sizes,prev,pager, next, jumper" :total="totalCount"></el-pagination>
        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import {
    number
  } from "mathjs";
  import xz from "../../common";
  import checkPermission from '@/utils/permission' // 权限判断函数
  export default {
    data() {
      return {
        listQuery: {
          PageModel: {
            Rows: 10,
            Page: 1,
            OrderInput: [{
              property: "createTime",
              order: 0
            }]
          },
          busiType: '', //1为暂支2为垫资
          attrMonth: '', //归属月
          CostMonth: '', //成本月
          payResult: '',
          IsCost: true,
          notWrittenAmount: '', //0为已销，1为未核销
          userId: Cookies.get("userid-b"),
          roleType: localStorage.loginRoletype,
        },
        showDropScreen: -1,
        activeName: '垫资成本',
        num1: 0,
        tableData: [],
        roletype: localStorage.loginRoletype,
        totalCount: 0,
        loading: false,
        proNameList: [], //项目列表
        multipleSelection: [],
        activeName2: '1',
        p_grouytype: [],
        p_grouytype1: [],
        busTypeList: ['全部', '薪资', '社保公积金', '个税', '商保', '增值税'],
        busTypeList2: ['全部', '发薪', '暂支', '报销', '其他'],
        setForm: {
          userid: Cookies.get("userid-b"),
          roletype: localStorage.loginRoletype,
          type: 1,
          day: "",
          hour: "",
          minute: "",
          second: "",
        },
        time: '',
        calList: [], //计算记录列表
        isBtnLoading: false,
        handelMonth: '',
        isExping: false,
        // 按钮权限参数
        butQuery: {
          path: '/advList',
          powerEnName: 'advList'
        },
        permissionLists: [],
      }
    },
    created() {
      if (this.$route.query.id != undefined && this.$route.query.id) {
        this.id = this.$route.query.id;
      }
      this.getButtonPower();
      this.getList();
      this.getProList();
      // this.getList();
    },
    methods: {
      checkPermission,
      // 获取按钮权限
      getButtonPower() {
        let that = this
        xz.getbtnPowerIdBypage(this.butQuery).then(res => {
          // console.log('按钮',res)
          if (res.status == 'ok') {
            let resmsg = res.msg
            if (!this.isNull(resmsg)) {
              for (let index = 0; index < resmsg.length; index++) {
                let element = resmsg[index];
                this.permissionLists.push(element.Enname);
              }
            } else {
              this.permissionLists = []
            }
          } else {
            this.permissionLists = []
          }
        })
      },
      //获取项目
      getProList() {
        let data = {
          projectname: "", // 项目名称
          projectid: "", // 项目id
          custname: "", //客户名称
          strAchieveowner: "", // 业绩归属人
          strservuserid: "", // 客服
          strBusiStat: "", //项目状态
          strpartner2: "", //合伙人
          perpage: 100000000,
          currpage: 1,
          strorgancode: "",
          roletype: this.roletype,
        }
        xz.getProjectLists(data).then((res) => {
          if (res.status == "ok") {
            this.proNameList = res.msg;
          } else {
            this.proNameList = [];
          }
        });
      },
      currentChange(val) {
        this.listQuery.PageModel.Page = Number(val);
        this.getList();
      },
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`);
        this.listQuery.PageModel.Page = 1;
        this.listQuery.PageModel.Rows = val;
        this.getList();
      },
      searchHandle() {
        this.listQuery.PageModel.Page = 1;
        this.getList();
      },
      getList() {
        if (this.activeName2 == '1') {
          this.loading = true;
          xz.AdvanceFun(this.listQuery, 'GettemporaryCostsList').then(res => {
            if (res.status == 'ok') {
              this.tableData = res.data.data;
              this.totalCount = res.data.pageModel.totalCount;
              this.loading = false;
            } else {
              this.tableData = [];
              this.totalCount = 0;
              this.loading = false;
            }
          })
        }
      },
      //筛选下拉
      dropDownScreen() {
        if (this.showDropScreen == -1) {
          this.showDropScreen = 1;
        } else if (this.showDropScreen == 1) {
          this.showDropScreen = -1;
        }
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      toDtl(row) {
        this.$router.push({
          path: '/reaPaymentDtl',
          // query: {
          //   activeName: row.Id
          // }
        })
      },
      toPayment(row) {},
      changeTab() {
        if (this.activeName != '垫资成本') {
          this.$router.push({
            path: '/advList',
            query: {
              activeName: this.activeName
            }
          })
        }
      },
      changeTab2() {
        if (this.activeName2 == 0) {
          this.GetCalcuTransientCostSettings();
          this.GetCalcTransientCostsList();
        } else {
          this.getList()
        }
      },
      changeRidio() {
        if (this.setForm.type == 1) {
          this.setForm.day = '';
          this.time = '';
        } else {
          this.time = '23:59:59';
        }
      },
      onSubmit() {
        if (this.setForm.type != 1 && (!this.time || !this.setForm.day)) {
          this.$message.warning('请选择自动计算时间')
        } else {
          let arr = this.time.split(':');
          this.setForm.hour = arr[0];
          this.setForm.minute = arr[1];
          this.setForm.second = arr[2];
          this.isBtnLoading = true;
          xz.AdvanceFun(this.setForm, 'CalcuTransientCostSettings').then(res => {
            if (res.status == 'ok') {
              this.$message.success('保存成功');
              this.isBtnLoading = false;
            } else {
              this.$message.error(res.msg);
              this.isBtnLoading = false;
            }
          })
        }
      },
      GetCalcuTransientCostSettings() {
        xz.GetCalcuTransientCostSettings().then(res => {
          if (res.status == 'ok') {
            this.setForm.type = number(res.data.type)
            this.setForm.day = number(res.data.day)
            if (this.setForm.type != 1) {
              this.time = res.data.hour + ':' + res.data.minute + ':' + res.data.second;
            }
          } else {}
        })
      },
      //手动计算
      handelCal() {
        if (this.handelMonth) {
          this.isBtnLoading = true;
          xz.CalcTransientCostsManually(this.handelMonth, '手工', 2).then(res => {
            if (res.status == 'ok') {
              this.$message.success('刷新成功')
              this.isBtnLoading = false;
            } else {
              this.$message.error(res.msg)
              this.isBtnLoading = false;
            }
          })
        } else {
          this.$message.warning('请选择月份')
        }
      },
      GetCalcTransientCostsList() {
        let data = {
          pageSize: 10,
          pageNum: 1,
          type: 1
        }
        xz.GetCalcTransientCostsList(data).then(res => {
          if (res.status == 'ok') {
            this.calList = res.data.data
          } else {
            this.calList = [];
          }
        })
      },
      //计提
      ProfitProvision(id, provision) {
        if (!this.loading) {
          this.loading = true;
          let data = {
            userId: Cookies.get("userid-b"),
            roleType: localStorage.loginRoletype,
            id,
            provision
          }
          xz.AdvanceFun(data, 'ProfitProvision').then(res => {
            if (res.status == 'ok') {
              this.$message.success('计提成功');
              this.getList();
              this.loading = false;
            } else {
              this.$message.error(res.msg);
              this.getList();
              this.loading = false;
            }
          })
        }
      },
      mulProfitProvision() {
        if (this.multipleSelection.length > 0) {
          let arr = [];
          let provision = this.multipleSelection.provision;
          let canDo = true;
          this.multipleSelection.forEach((element, index) => {
            if (element.provision != provision) {
              canDo = false;
            }
            arr.push(element.id)
            if (index == this.multipleSelection.length - 1) {
              if (canDo) {
                this.ProfitProvision(arr.toString(), provision)
              } else {
                this.$message.warning('请选择相同计提状态的操作');
              }
            }
          });
        }
      },
      allProvision() {
        let data = JSON.parse(JSON.stringify(this.listQuery));
        data.ToProvision = 1;
        data.PageModel.Rows = 100000;
        data.PageModel.Page = 1;
        xz.AdvanceFun(data, 'GettemporaryCostsList').then(res => {
          if (res.status == 'ok') {
            this.$message.success('全部计提成功');
            this.getList();
            this.loading = false;
          } else {
            this.$message.error(res.msg);
            this.getList();
            this.loading = false;
          }
        })
      },
      expList() {
        this.isExping = true;
        let d = JSON.parse(JSON.stringify(this.listQuery));
        d.PageModel.rows = 100000;
        xz.AdvanceExpFun(d, 'ExportGettemporaryCostsList').then(res => {
          if (res) {
            try {
              var data = new Blob([res], {
                type: "application/vnd.ms-excel;charset=utf-8"
              });
              var downloadUrl = window.URL.createObjectURL(data);
              var anchor = document.createElement("a");
              anchor.href = downloadUrl;
              anchor.download = "垫资成本报表列表.xlsx";
              anchor.click();
              window.URL.revokeObjectURL(data);
              this.isExping = false;
            } catch (e) {
              this.isExping = false;
              this.$message.error('导出异常')
            }
          } else {
            this.$message.error('导出失败');
            this.getList();
            this.isExping = false;
          }
        })
      },
      //判断是否为空(包含0)
      isNull(o) {
        return (
          o == undefined ||
          o == "undefined" ||
          (o + "").indexOf("undefined") > -1 ||
          o == null ||
          o == "" ||
          o == "null" ||
          o == [] ||
          o == 0 ||
          o == "NaN"
        );
      },
    }
  }
</script>

<style lang="scss" scoped>
  .ftabs {
    background: #fff;
    padding: 10px 16px 16px;
    margin-bottom: 16px;
  }

  .ftabBtn {
    padding: 10px 0;
  }

  .r_dropDownScreen {
    width: 100%;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    background-color: #fff;
  }

  .re_down_form .el-form-item {
    margin-bottom: 3px;
    margin-right: 0;
  }

  .scr_icon.i_txt {
    display: inline-block;
    font-size: 12px;
    cursor: pointer;
  }

  .calTitle {
    font-size: 14px;
    font-weight: bold;
  }

  .titleLine {
    font-size: 16px;
    color: #F59A23;
    margin-right: 3px;
  }

  .calList {
    padding-left: 40px;
    margin-top: 20px;
  }

  .calItem {
    margin-bottom: 10px;
  }

  .record {
    margin-top: 10px;
    color: #797979;
  }

  .checkedgroup {
    display: flex;
    /* flex-flow: wrap; */
  }

  .pro_down_box {
    padding-left: 29px;
  }
</style>
<style>
  .page_finCost .eleTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_finCost .doc_table .el-table__body td.el-table__cell {
    padding: 5px 0;
  }

  .page_finCost .doc_table .el-table__body th.el-table__cell {
    padding: 8px 0;
  }

  .page_finCost .el-input__icon {
    height: 32px;
    line-height: 32px;
  }

  .page_finCost .el-input-group__append,
  .el-input-group__prepend {
    padding: 0 10px;
    background: #fff;
  }

  .page_finCost .injuryTabBtn .el-button--text {
    color: #19bd92;
    font-size: 13px;
    padding: 0;
  }

  .page_finCost .checkedgroup .el-checkbox {
    margin-right: 10px;
  }

  .page_finCost .el-checkbox__label {
    padding-left: 3px;
  }

  .page_finCost .checkedgroup2 .el-checkbox {
    margin-bottom: 5px;
  }
</style>